import { AlertCircle, Inbox } from "lucide-react";

export function PageHeader({ eyebrow, title, description, meta, actions, children }) {
  return <header className="ops-page-header">
    <div className="min-w-0">
      {eyebrow && <div className="ops-eyebrow">{eyebrow}</div>}
      <h1>{title}</h1>
      {description && <p>{description}</p>}
      {meta && <div className="ops-header-meta">{meta}</div>}
    </div>
    {(actions || children) && <div className="ops-header-actions">{actions || children}</div>}
  </header>;
}

export function MetricCard({ label, value, detail, tone = "neutral", onClick }) {
  const Tag = onClick ? "button" : "div";
  return <Tag onClick={onClick} className={`ops-metric ops-metric--${tone}`}>
    <span className="ops-metric-label">{label}</span><strong>{value}</strong>
    {detail && <span className="ops-metric-detail">{detail}</span>}
  </Tag>;
}

export function EmptyState({ title, description, warning = false }) {
  const Icon = warning ? AlertCircle : Inbox;
  return <div className="ops-empty" role="status"><Icon aria-hidden="true"/><strong>{title}</strong>{description && <p>{description}</p>}</div>;
}

export function ProgressBar({ value, label }) {
  const safe = Math.max(0, Math.min(100, Number(value) || 0));
  return <div className="ops-progress"><div className="ops-progress-copy"><span>{label}</span><strong>{safe}%</strong></div><div className="ops-progress-track"><span style={{width:`${safe}%`}} /></div></div>;
}

export function LoadingState({ label = "Loading current information…" }) {
  return <div className="ops-loading" role="status"><span aria-hidden="true"/>{label}</div>;
}

export function SectionCard({ title, description, children }) {
  return <section className="ops-section-card">{title&&<div className="ops-section-card__header"><strong>{title}</strong>{description&&<p>{description}</p>}</div>}{children}</section>;
}

export function SubmissionSummary({ data, submittedAt, submittedBy, reversed }) {
  const entries=Object.entries(data||{}).filter(([,value])=>value!==""&&value!=null);
  return <div className={`submission-summary ${reversed?"submission-summary--reversed":""}`}><div className="submission-summary__heading"><strong>{reversed?"Reversed submission":"Submitted information"}</strong>{(submittedAt||submittedBy)&&<small>{submittedBy||"Team member"}{submittedAt?` · ${new Date(submittedAt).toLocaleString()}`:""}</small>}</div><dl>{entries.map(([key,value])=><div key={key}><dt>{key.replaceAll("_"," ").replace(/^./,c=>c.toUpperCase())}</dt><dd>{Array.isArray(value)?value.join(", "):typeof value==="boolean"?(value?"Yes":"No"):typeof value==="object"?"Attached information":String(value)}</dd></div>)}</dl>{!entries.length&&<p className="text-sm text-slate-500">No answers were recorded.</p>}</div>;
}
